import { useCallback, useEffect, useState } from "react"
import { useLocationContext } from "../utils/locationContext/LocationContext"
import i18n from "../i18n/i18n"

const parameters = ['country', 'locality', 'postal_code', 'street_number', 'route', 'sublocality_level_1', 'sublocality', 'premise']
// pac-input -> id
export const useAutoCompleteLocation = ({ aroundMe = false, isGeoCode = true }) => {
    const [location, setLocation] = useState(null)
    const [currentLocation, setCurrentLocation] = useState(null)
    const { isLoaded } = useLocationContext()
    const [getCurrentLocation, setGetCurrentLocation] = useState(false)

    const handleAroundMeClick = (e) => {
        const isAround = e?.target?.closest?.('.around-me')
        const container = document.querySelector('.pac-container')
        const input = e?.target?.closest?.('.pac-target-input')

        if (isAround) {
            setGetCurrentLocation(true)
            container?.classList.remove('dis-block')
            container?.classList.add('dis-none')
        } else if (input) {
            if (container?.classList.contains('dis-block')) return
            container?.classList.remove('dis-none')
            container?.classList.add('dis-block')
        } else {
            container?.classList.remove('dis-block')
            container?.classList.add('dis-none')
        }
    }

    useEffect(() => {
        if (aroundMe) {
            const listener = window.addEventListener('click', handleAroundMeClick)
            return () => {
                window.removeEventListener('click', listener)
            }
        }
    }, [])
//PlaceAutocompleteElement 
    useEffect(() => {
        if (isLoaded) {
            const autoComplete = new window.google.maps.places.Autocomplete(document.getElementById("pac-input"), {
                fields: ["geometry", "icon", "name", 'place_id', 'formatted_address', 'adr_address', 'address_components'],
                // types: ["doctor", "hair_care", "hospital", "physiotherapist", "pharmacy"],
                ...(isGeoCode ? { types: ["geocode"] } : null)

            })
            autoComplete.setComponentRestrictions({ country: ['fr'] })
            autoComplete.addListener('place_changed', () => {
                const place = autoComplete.getPlace()

                if (!place.place_id) {
                    return
                }

                const otherComponents = {}
                parameters.forEach((parameters) => {
                    const data = place?.address_components?.find?.((obj) => {
                        return obj.types.includes(parameters)
                    })
                    if (data) {
                        otherComponents[parameters] = parameters == 'route' ? data?.short_name : data?.long_name
                        if (parameters == 'route' || parameters == 'street_number' || parameters == 'premise') {
                            otherComponents['full_street'] = `${otherComponents?.premise || ''} ${otherComponents?.street_number || ''} ${otherComponents?.route || ''}`?.trim?.() || ''
                        }
                        if (parameters == 'sublocality_level_1' && (!otherComponents?.street_number && !otherComponents?.route)) {
                            otherComponents['full_street'] = data?.short_name
                        } else if (parameters == 'sublocality' && (!otherComponents?.street_number && !otherComponents?.route && !otherComponents?.sublocality_level_1)) {
                            otherComponents['full_street'] = data?.short_name
                        }
                    }
                })

                if (aroundMe) {
                    const container = document.querySelector('.pac-container')
                    container?.classList.remove('dis-block')
                    container?.classList.add('dis-none')
                }
                setCurrentLocation(null)
                setGetCurrentLocation(false)
                setLocation({
                    name: place.formatted_address,
                    latLng: {
                        lat: place.geometry?.location?.lat(),
                        lng: place.geometry?.location?.lng()
                    },
                    ...otherComponents

                })
            })
        }
    }, [isLoaded])

    useEffect(() => {
        if (getCurrentLocation) {
            getGeoLocation()
            const input = window.document.querySelector('#pac-input')
            if (input) {
                input.value = i18n.t('near_me')
            }
        }
    }, [getCurrentLocation])

    const getGeoLocation = async () => {
        if (!navigator.geolocation) {
            return null; // Geolocation is not supported by this browser.
        }

        const result = await navigator.permissions.query({ name: 'geolocation' });

        if (result.state === 'denied') {
            return null; // Geolocation access denied.
        }

        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            });

            const coordinates = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            setCurrentLocation(() => {
                return {
                    ...coordinates
                }
            })

            return coordinates;
        } catch (error) {
            return null; // Handle cases where the geolocation request fails.
        }
    }

    const reset = useCallback((data) => {
        setLocation(data || null)
    }, [])

    return { location, reset, isLoaded, currentLocation, getGeoLocation }
}